<template>
	<el-container>
		<el-header class="header">
			<el-button round class="el-icon-caret-left" @click="diaAnterior" />
			<el-button type="text" @click="mostrarCalendario = true">
				<span>{{ $store.getters['visitas/diaAmigable'] }}</span>
			</el-button>
			<el-button round class="el-icon-caret-right" @click="diaSiguiente" />
		</el-header>
		<!-- Calendario -->
		<el-dialog title="Seleccionar fecha" :visible.sync="mostrarCalendario" width="300px" center>
			<el-date-picker
				v-model="fechaSeleccionada"
				type="date"
				:visible.sync="mostrarCalendario"
				placeholder="Selecciona una fecha"
				@change="seleccionarFecha"
				:picker-options="{
					disabledDate: fecha => {
						const hoy = new Date();
						hoy.setHours(0, 0, 0, 0);
						return fecha >= hoy;
					},
				}"
			/>
		</el-dialog>
		<el-main>
			<template v-if="cargando">
				<div class="skeleton-container">
					<div class="skeleton-card" v-for="n in 5" :key="n"></div>
				</div>
			</template>
			<template v-else>
				<!-- Clientes No Atendidos -->
				<div v-if="esHoy && (clientesPorTurno.pendientes.manana.length || clientesPorTurno.pendientes.tarde.length)">
					<el-divider content-position="center">
						Clientes del Día
					</el-divider>
					<div v-if="clientesPorTurno.pendientes.manana.length">
						<el-tag type="info" size="medium" class="tag">Turno: Mañana</el-tag>
						<cliente-card
							v-for="cliente in clientesPorTurno.pendientes.manana"
							:key="`pendiente-mañana-${cliente.generalId}`"
							:cliente="cliente"
							estado_realizado="Pendiente"
							:esPendiente="estaPendiente(cliente.generalId)"
							@cambiarEstado="actualizarEstado"
							:irADetalleCliente="irADetalleCliente"
						/>
					</div>
					<div v-if="clientesPorTurno.pendientes.tarde.length">
						<el-tag type="info" size="medium" class="tag">Turno: Tarde</el-tag>
						<cliente-card
							v-for="cliente in clientesPorTurno.pendientes.tarde"
							:key="`pendiente-tarde-${cliente.generalId}`"
							:cliente="cliente"
							estado_realizado="Pendiente"
							:esPendiente="estaPendiente(cliente.generalId)"
							:irADetalleCliente="irADetalleCliente"
							@cambiarEstado="actualizarEstado"
						/>
					</div>
				</div>
				<!-- CLIENTES COMPLETADOS -->
				<div
					v-if="esHoy && (clientesPorTurno.completados.manana.length || clientesPorTurno.completados.tarde.length)"
					class="fondo-completados"
				>
					<el-divider content-position="center">
						Realizados
					</el-divider>
					<div v-if="clientesPorTurno.completados.manana.length">
						<el-tag type="success" size="medium" class="tag">Turno: Mañana</el-tag>
						<cliente-card
							v-for="cliente in clientesPorTurno.completados.manana"
							:key="`completado-mañana-${cliente.id}`"
							:cliente="cliente"
							estado_realizado="completado"
							:irADetalleCliente="irADetalleCliente"
						/>
					</div>
					<div v-if="clientesPorTurno.completados.tarde.length">
						<el-tag type="success" size="medium" class="tag">Turno: Tarde</el-tag>
						<cliente-card
							v-for="cliente in clientesPorTurno.completados.tarde"
							:key="`completado-tarde-${cliente.id}`"
							:cliente="cliente"
							estado_realizado="completado"
							:irADetalleCliente="irADetalleCliente"
						/>
					</div>
				</div>
				<!-- DÍAS PASADOS -->
				<div v-else-if="!esHoy">
					<cliente-card
						v-for="cliente in tableData"
						:key="cliente.generalId"
						:cliente="cliente"
						estado_realizado=""
						:mostrarHora="false"
						:irADetalleCliente="irADetalleCliente"
						:mostrarEstado="false"
					/>
				</div>
				<!-- CLIENTES NUEVOS -->
				<div v-if="esHoy && clientesPorTurno.nuevos.length">
					<el-divider content-position="center">Clientes fuera de ruta</el-divider>
					<cliente-card
						v-for="cliente in clientesPorTurno.nuevos"
						:key="`nuevo-${cliente.id}`"
						:cliente="cliente"
						estado_realizado="completado"
						:mostrarHora="false"
						:irADetalleCliente="irADetalleCliente"
					/>
				</div>
				<!-- Botón flotante solo para HOY -->
				<template v-if="esHoy">
					<el-button circle class="boton-flotante el-icon-plus" @click="irANuevoCliente" />
				</template>
			</template>
		</el-main>
		<el-footer class="footer">
			<el-button v-if="!esHoy" class="volver-hoy" round @click="volverAHoy">
				Volver a hoy
			</el-button>
			<div v-if="esHoy">
				Turno: <strong>{{ turnosDelDia.length ? turnosDelDia.join(' y ') : 'No hay turnos para hoy' }}</strong>
			</div>
		</el-footer>
	</el-container>
</template>
<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import moment from 'moment';
import 'moment/locale/es';
moment.locale('es');
import ClienteCard from '@/components/ClienteCard.vue';

export default {
	name: 'Visitas',
	components: {
		ClienteCard,
	},
	data() {
		return {
			mostrarCalendario: false,
			fechaSeleccionada: null,
			clientesPendientes: [],
			cargando: true,
		};
	},
	computed: {
		...mapGetters('visitas', ['diaHoy', 'fechaHistorica', 'tableData', 'modoHistorico', 'esHoy', 'clientesPorTurno']),
		...mapState('visitas', ['turnosDelDia']),
	},
	methods: {
		async actualizarEstado(clienteId, nuevoEstado) {
			try {
				await this.$store.dispatch('visitas/actualizarEstado', { clienteId, nuevoEstado });
				this.$message.success('Estado actualizado');
			} catch (error) {
				this.$message.error('No se pudo actualizar el estado');
			}
		},
		encontrarClientePorId(id) {
			return (
				this.clientesPorTurno.pendientes.manana.find(c => c.generalId === id) ||
				this.clientesPorTurno.pendientes.tarde.find(c => c.generalId === id)
			);
		},
		estaPendiente(clienteId) {
			return this.clientesPendientes.includes(clienteId);
		},
		async volverAHoy() {
			this.SET_MODO_HISTORICO(false);
			this.SET_DIAS_ATRAS(0);
			this.SET_SEMANA_OFFSET(0);
			await this.inicializarDiaActual();
			await this.fetchVisitas();
		},
		...mapActions('visitas', [
			'inicializarDiaActual',
			'fetchVisitas',
			'fetchVentasAnteriores',
			'diaAnterior',
			'diaSiguiente',
			'inicializarInstanciaVisitas',
		]),
		irADetalleCliente(row) {
			let id = row.id || (row.value && row.value.id);
			const fecha = this.modoHistorico ? this.fechaHistorica : this.$store.getters['visitas/fechaSeleccionada'];
			this.$router.push({ name: 'DetalleCliente', params: { id, fecha } });
		},
		...mapMutations('visitas', ['SET_MODO_HISTORICO', 'SET_DIAS_ATRAS', 'SET_SEMANA_OFFSET']),
		//Selecciona la fecha del calendario
		seleccionarFecha(fecha) {
			const hoy = moment();
			const fechaElegida = moment(fecha);
			const diasAtras = hoy.diff(fechaElegida, 'days');
			this.SET_DIAS_ATRAS(diasAtras);
			this.SET_MODO_HISTORICO(true);
			this.fetchVentasAnteriores();
		},
		irANuevoCliente() {
			const fecha = this.$store.getters['visitas/fechaSeleccionada'];
			this.$router.push({ name: 'DetalleCliente', params: { nuevo: true, fecha } });
		},
	},
	async beforeRouteEnter(to, from, next) {
		next(async vm => {
			vm.cargando = true;
			try {
				const esHistorico = vm.$store.getters['visitas/modoHistorico'];
				const esFuturo = vm.$store.getters['visitas/esFuturo'];

				if (esHistorico) await vm.fetchVentasAnteriores();
				else if (esFuturo) await vm.fetchVisitas();
				else {
					await vm.inicializarDiaActual();
					await vm.fetchVisitas();
				}
			} finally {
				vm.cargando = false;
			}
		});
	},
};
</script>
<style scoped>
.skeleton-container {
	padding: 10px;
}
.skeleton-card {
	background: linear-gradient(90deg, #eee, #f5f5f5, #eee);
	height: 80px;
	border-radius: 8px;
	margin-bottom: 16px;
	animation: pulse 1.5s infinite;
}
@keyframes pulse {
	0% {
		background-position: -200px 0;
	}
	100% {
		background-position: calc(200px + 100%) 0;
	}
}
.header {
	display: flex;
	justify-content: space-around;
	align-items: center;
}
.el-main {
	height: auto !important;
	background-color: rgb(255, 255, 255);
}
.tag {
	margin: 20px 20px;
}
.boton-flotante {
	position: fixed;
	bottom: 80px;
	right: 20px;
	width: 50px;
	height: 50px;
	font-size: larger;
	background-color: #1a252f;
	color: white;
	border: none;
	text-align: center;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}
.footer {
	background-color: #1a252f;
	color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0 !important;
}
.volver-hoy {
	margin: 16px auto;
	display: block;
}
.el-container {
	margin-bottom: 0px !important;
	min-height: 92vh;
}
</style>
